import * as Trix from 'trix/dist/trix';
import 'trix/dist/trix.css';

// Any overrides or Trix configuration can go here...

export default Trix;
